import React, { useEffect, useRef, useState } from 'react';

type PinInputProps = {
  length?: number;
  value: string;
  onChange: (value: string) => void;
};

export const PinInput: React.FC<PinInputProps> = ({ length = 6, value, onChange }) => {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (index: number, val: string) => {
    if (!/^\d?$/.test(val)) return;

    const newValue = value.split('');
    newValue[index] = val;
    onChange(newValue.join(''));

    if (val && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    const key = e.key;

    // 🔢 Хэрвээ digit дарсан бол
    if (/^\d$/.test(key)) {
      e.preventDefault(); // browser default insert-ийг болиулна

      const newValue = value.split('');
      newValue[index] = key;
      onChange(newValue.join(''));

      if (index < length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
      return;
    }

    // ⬅️ Backspace логик
    if (key === 'Backspace') {
      e.preventDefault();

      const newValue = value.split('');
      if (newValue[index]) {
        newValue[index] = '';
        onChange(newValue.join(''));
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);

    onChange(pasted);
    inputsRef.current[pasted.length - 1]?.focus();
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    // cursor хаана байхаас үл хамаараад бүгдийг select
    e.target.setSelectionRange(0, e.target.value.length);
  };

  return (
    <div className="flex flex-row justify-between">
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el) as any}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ''}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          onFocus={handleFocus}
          className="
    w-12 h-12 text-center text-lg
    border border-gray-300 rounded-lg
    focus:outline-none focus:ring-2 focus:ring-blue-500
  "
        />
      ))}
    </div>
  );
};

// Timmer components

type ResendCodeProps = {
  initialSeconds?: number;
  onResend: () => Promise<void> | void;
};

export const ResendCode: React.FC<ResendCodeProps> = ({ initialSeconds = 60, onResend }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const isDisabled = seconds > 0;

  useEffect(() => {
    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  const handleResend = async () => {
    if (isDisabled) return;

    await onResend();
    setSeconds(initialSeconds);
  };

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={handleResend}
      className={`
        text-[14px] font-manrope font-normal
        transition
        ${isDisabled ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:underline'}
      `}
    >
      {isDisabled ? `Код дахин илгээх (${seconds}с)` : 'Код дахин илгээх'}
    </button>
  );
};
